import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import { ar, en } from "@/locales";
import { prefs, usePrefs } from "./prefs";

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: { translation: typeof en };
  }
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: prefs.get().lang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
});

prefs.subscribe(() => {
  const { lang } = prefs.get();
  if (i18n.language !== lang) void i18n.changeLanguage(lang);
});

export { i18n };

/** Typed `t` plus the current language and direction. */
export function useT() {
  const { t } = useTranslation();
  const { lang } = usePrefs();
  return { t, lang, dir: (lang === "ar" ? "rtl" : "ltr") as "rtl" | "ltr", rtl: lang === "ar" };
}
